import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslocoDirective } from "@jsverse/transloco";
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { CoreCommonModule } from '@core/common.module';
import { CoreTouchspinModule } from '@core/components/core-touchspin/core-touchspin.module';
import { NavbarComponent } from 'app/layout/components/navbar/navbar.component';
import { NavbarBookmarkComponent } from 'app/layout/components/navbar/navbar-bookmark/navbar-bookmark.component';
import { NavbarSearchComponent } from 'app/layout/components/navbar/navbar-search/navbar-search.component';
import { NavbarNotificationComponent } from 'app/layout/components/navbar/navbar-notification/navbar-notification.component';
import { SharedModule } from 'app/main/shared/shared/shared.module';
import { WorkspaceFormModalComponent } from '../workspace-form-modal/workspace-form-modal.component';
import { AddonPermissionPipe } from 'app/pipes/addon-permission.pipe';


@NgModule({
  declarations: [
    NavbarComponent,
    NavbarSearchComponent,
    NavbarBookmarkComponent,
    NavbarNotificationComponent,
    WorkspaceFormModalComponent
  ],
  imports: [
    RouterModule, 
    NgbModule, 
    CoreCommonModule, 
    CoreTouchspinModule, 
    SharedModule, 
    NgSelectModule, 
    TranslocoDirective,
    AddonPermissionPipe
  ],

  exports: [NavbarComponent]
})
export class NavbarModule { }
